import React from "react";

const InputTextArea = ({
  label,
  divClassName,
  labelClassName,
  textareaClassName,
  placeholder,
  name,
  value,
  setFieldValue,
  handleBlur,
  error,
  touched,
  onKeyDown,
  showCounter = true, // new prop, default true
  maxCharacters = null, // new prop, default null (no limit)
  baseHeight = null, // new prop, default null (no minimum height, natural sizing)
  ...rest
}) => {
  const textareaRef = React.useRef(null);

  const handleTextChange = (event) => {
    const newText = event.target.value;
    if (maxCharacters === null || newText.length <= maxCharacters) {
      setFieldValue(name, newText);
    }
    // Only apply auto-resize if baseHeight is explicitly set
    // Otherwise, respect fixed heights from className
    if (textareaRef.current && baseHeight !== null) {
      // If baseHeight is specified, use it as minimum (for offer description)
      textareaRef.current.style.height = baseHeight + "px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height =
        (scrollHeight > baseHeight ? scrollHeight : baseHeight) + "px";
    }
    // If baseHeight is null, don't touch height - let className handle it
  };

  React.useEffect(() => {
    // Only apply auto-resize if baseHeight is explicitly set
    // Otherwise, respect fixed heights from className
    if (textareaRef.current && baseHeight !== null) {
      // If baseHeight is specified, use it as minimum (for offer description)
      textareaRef.current.style.height = baseHeight + "px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height =
        (scrollHeight > baseHeight ? scrollHeight : baseHeight) + "px";
    }
    // If baseHeight is null, don't touch height - let className handle it
  }, [value, baseHeight]);

  return (
    <>
      <div className={divClassName + " relative"}>
        <p className={labelClassName}>{label}</p>
        <textarea
          ref={textareaRef}
          className={textareaClassName}
          style={{ scrollbarWidth: 'none' }}
          placeholder={placeholder}
          maxLength={maxCharacters}
          name={name}
          value={value}
          onChange={handleTextChange}
          onBlur={handleBlur}
          onKeyDown={onKeyDown}
          {...rest}
        ></textarea>
        {showCounter && maxCharacters && (
          <div className="absolute bottom-2 right-3 text-[#D9D9D9] text-[10px] font-poppins">
            {value?.length}/{maxCharacters}
          </div>
        )}
      </div>
      {error && touched ? (
        <div className="ms-1 text-start w-full">
          <span className="text-red-600 text-[12px] sm:text-[13px] md:text-[14px] font-[500]">
            {error}
          </span>
        </div>
      ) : null}
    </>
  );
};

export default InputTextArea;
